module.exports = __webpack_public_path__ + "img/12.12aa8c23.png";